var React = require('react');

function MouseAlt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M224 0h-64A160 160 0 0 0 0 160v192a160 160 0 0 0 160 160h64a160 160 0 0 0 160-160V160A160 160 0 0 0 224 0zm0 160a32 32 0 0 1-64 0v-32a32 32 0 0 1 64 0z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M224 160a32 32 0 0 1-64 0v-32a32 32 0 0 1 64 0z","className":"fa-primary","key":2})]);
}

MouseAlt.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = MouseAlt;

MouseAlt.default = MouseAlt;
